import Cookies from 'js-cookie';

export const useCookies = () => {
	const setCookie = (name: string, value: string, options?: Cookies.CookieAttributes) =>
		Cookies.set(name, value, options);

	const getCookie = (name: string) => Cookies.get(name);

	const removeCookie = (name: string) => Cookies.remove(name);
	return {
		setCookie,
		getCookie,
		removeCookie,
	};
};
